export enum ClientDashboardTabsEnum {
  HOME = 1,
  MY_MESSAGES = 2,
  MY_SESSIONS = 3,
  MY_THERAPISTS = 4,
  PACKAGES = 5,
}

